module.exports = __webpack_public_path__ + "static/media/box-desafio-bomba.d7d0b8c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/desafios/box-desafio-bomba.png
// module id = 1251
// module chunks = 0